import { Store } from 'lucide-react';

/** Two letters: first and last word of the name (brand/components/Avatar). */
export function initialsOf(name: string | null | undefined): string | null {
  const words = (name ?? '').trim().split(/\s+/).filter(Boolean);
  const first = words[0]?.[0];
  if (!first) return null;
  const last = words.length > 1 ? words[words.length - 1]?.[0] : undefined;
  return `${first}${last ?? ''}`.toUpperCase();
}

/**
 * A round identity marker. No name yet (only a phone number): a shop glyph instead of digits.
 * `brand` marks the selected conversation's merchant or the signed-in user.
 */
export function Avatar({
  name,
  size = 'md',
  brand = false,
}: {
  name: string | null | undefined;
  size?: 'md' | 'sm';
  brand?: boolean;
}) {
  const initials = initialsOf(name);
  return (
    <span
      className={`fl-avatar ${size === 'sm' ? 'fl-avatar--sm' : ''} ${brand ? 'fl-avatar--brand' : ''}`}
      aria-hidden
    >
      {initials ?? <Store size={size === 'sm' ? 16 : 20} strokeWidth={1.75} />}
    </span>
  );
}
